import type { CSSProperties, ReactNode } from 'react';

export type PageContainerWidth = 'default' | 'wide' | 'full';

export interface PageContainerProps {
  children: ReactNode;
  width?: PageContainerWidth;
  className?: string;
  style?: CSSProperties;
}

const WIDTHS: Record<Exclude<PageContainerWidth, 'full'>, string> = {
  default: 'var(--page-max-width)',
  wide: 'var(--shell-max-width)',
};

export function PageContainer({
  children,
  width = 'default',
  className,
  style,
}: PageContainerProps) {
  return (
    <div
      className={['mx-auto w-full', className].filter(Boolean).join(' ')}
      style={{
        maxWidth: width === 'full' ? undefined : WIDTHS[width],
        paddingInline: width === 'full' ? undefined : 'var(--page-gutter)',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
